import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { companyInfo } from "../../data/mock";
import Reveal from "../ui-custom/Reveal";
import GlowBackdrop from "../ui-custom/GlowBackdrop";

const VisionSection = () => {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <GlowBackdrop variant="section" />
      <div className="relative z-10 max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-14 items-center">
        <Reveal>
          <span className="section-eyebrow mb-4 block">Our Vision</span>
          <h2 className="font-display font-bold uppercase tracking-wide text-3xl md:text-4xl lg:text-5xl text-foreground leading-tight">
            {companyInfo.visionTitle}
          </h2>
          <p className="mt-6 text-base md:text-lg text-muted-foreground leading-relaxed">{companyInfo.vision}</p>
          <Link
            to="/about-us"
            className="mt-8 inline-flex items-center gap-2 text-qcyan font-semibold tracking-wide text-sm hover:gap-3 transition-all"
          >
            Let&rsquo;s Do It Together <ArrowRight size={16} />
          </Link>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="glass-panel rounded-2xl p-8 md:p-10">
            <span className="section-eyebrow mb-4 block">Get To Know Us</span>
            <div className="space-y-5">
              {companyInfo.aboutLong.slice(0, 2).map((para, i) => (
                <p key={i} className="text-sm md:text-base text-muted-foreground leading-relaxed">
                  {para}
                </p>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default VisionSection;
